import { Component, OnInit, AfterViewInit, OnChanges, EventEmitter, ChangeDetectorRef, ViewChild, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { Subscription } from 'rxjs';
import { AddAssessmentScoresComponent } from '../assessment-data-category-table/add-assessment-scores/add-assessment-scores.component';
import { AssessmentDataCategory } from '../assessment-data-category';
import { GeneralConfirmationComponent } from '../../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { AssessmentService } from '../../../../student360/assessment/assessment.service';
import { SharedService } from '../../../../shared-components/shared.service';
import { UserPermission } from '../../../../shared-components/user/user-permission.model';
import { SecurityService } from '../../../../shared-components/security/security.service';

@Component({
    selector: 'app-assessment-data-table',
    templateUrl: './assessment-data-table.component.html',
    styleUrls: ['./assessment-data-table.component.css']
})
export class AssessmentDataTableComponent implements OnInit, AfterViewInit, OnChanges {

    // Properties
    private _sort: MatSort;
    @Input() data: TylerMatTableDataSource;
    @Input() fields: string[];
    @Input() dataCategory: AssessmentDataCategory;
    @Input() minTableWidth: number;
    @Input() showFilters = true;
    @Input() showActionButton = true;
    @Input() triggerChanges: EventEmitter<any>;
    @Output() getAssessmentDataEvent = new EventEmitter();
    triggerChangeSubscription: Subscription;
    fieldsColumns: string[] = [];
    V9UserPermissions: UserPermission[] = [];
    userCanDelete: boolean;
    userCanProcess = false;

    constructor(
        private assessmentService: AssessmentService,
        private changeDetector: ChangeDetectorRef,
        private dialog: MatDialog,
        private sharedService: SharedService,
        private securityService: SecurityService,
    ) { }

    get sort(): MatSort {
        return this._sort;
    }

    @ViewChild(MatSort, { static: true }) set sort(value: MatSort) {
        this._sort = value;
        if (this.data) {
            this.data.sort = this._sort;
            this.setSorting();
        }
    }

    // Event Functions
    ngOnInit() {
        this.fields.forEach(f => {
            this.fieldsColumns.push(f);
        });
        if (this.showActionButton == true) {
            this.fieldsColumns.push('Actions');
        }
        // POST: subscribes to manual changes
        if (this.triggerChanges) {
            this.triggerChangeSubscription = this.triggerChanges.subscribe(() => {
                this.changeDetector.markForCheck();
            });
        }
        this.V9UserPermissions = this.securityService.userPermissions;
        const isDelete = this.V9UserPermissions.filter(permission => permission.PermissionCode == 'AS_DSTS');
        if ((isDelete != undefined && isDelete != null && isDelete.length > 0)) {
            this.userCanDelete = true;
        }
        // Maintain Scores for Individual Students
        const userCanAdd = this.V9UserPermissions.filter(permission => (permission.PermissionCode == 'AS_MSFIS'))[0];
        if (userCanAdd != undefined && userCanAdd != null) {
            this.userCanProcess = true;
        }
    }

    ngAfterViewInit() {
        // POST: sets the table data's sort
        this.setSorting();
    }

    ngOnChanges() {
        // POST: unsubscribes to manual changes and sets the table data's sort
        if (this.triggerChangeSubscription) {
            this.triggerChangeSubscription.unsubscribe();
        }
        this.setSorting();
    }

    // Methods
    setSorting() {
        // PRE: table data
        // POST: sets the table data's sort
        if (this.data && this.sort) {
            this.data.sort = this.sort;
            this.data.sortingDataAccessor = (data: any, sortHeaderId: string): string | number => {
                let value = data[sortHeaderId];
                const dateRegex = /\d{2}\/\d{2}\/\d{2}/y;
                if (value) {
                    if (dateRegex.test(value)) {
                        value = new Date(value);
                        return value.getTime();
                    } else {
                        return this.data.defaultSortingAccessor(data, sortHeaderId);
                    }
                } else {
                    return '';
                }
            };
            this.sort.sort({
                id: this.fields[0],
                start: 'asc',
                disableClear: true
            });
        }
    }

    fieldTrackBy(index: number, item: string) {
        return item + index;
    }

    editAssessmentClick(assessmentData: any) {
        let testInstanceId = 0;
        if (assessmentData && assessmentData.TestInstanceId) {
            testInstanceId = parseInt(assessmentData.TestInstanceId, 10);
        }
        const dialogRef = this.dialog.open(AddAssessmentScoresComponent, {
            height: '100vh',
            width: '60vw',
            disableClose: true,
            data: {
                instanceId: testInstanceId,
                testMasterLayoutVersionId: 0,
                assessmentData: assessmentData,
                editMode: true
            }
        });
        dialogRef.afterClosed().subscribe(action => {
            if (action == 'save') {
                this.getAssessmentDataEvent.emit(true);
            }
        });
    }

    deleteAssessmentClick(assessmentData: any) {
        let testInstanceId = 0;
        if (assessmentData && assessmentData.TestInstanceId) {
            testInstanceId = parseInt(assessmentData.TestInstanceId, 10);
        }

        const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
        });
        deleteConfirmDialog.componentInstance.headerLabel = 'Delete Assessment';
        deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete this record? ';
        deleteConfirmDialog.componentInstance.okButtonLabel = 'Delete';
        deleteConfirmDialog.componentInstance.confirmEvent.subscribe((deleteObject: boolean) => {
            if (deleteObject) {
                this.assessmentService.deleteAssessmentById(testInstanceId).subscribe(res => {
                    this.sharedService.showGoodSnackbar();
                    this.getAssessmentDataEvent.emit(true);
                });
            }
        });
    }
}